/**
 * Marca do Vertical Lab, em texto.
 *
 * É um logotipo tipográfico de propósito: o arquivo gráfico do RESCUE-LAB
 * (um veículo com cruz) não representa este projeto. Quando houver um logo
 * próprio, é só trocar o conteúdo deste componente — quem o usa não muda.
 *
 * A cor segue o tema pelos tokens do CSS, então a marca acerta o fundo claro e
 * o escuro sem receber o tema por prop.
 */
export type VarianteMarca = 'horizontal' | 'logo' | 'icon'

interface Props {
  variante: VarianteMarca
  className?: string
}

export function MarcaVerticalLab({ variante, className }: Props) {
  const classes = ['marca-vertical-lab', `marca-vertical-lab--${variante}`, className]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={classes} role="img" aria-label="Vertical Lab">
      {variante === 'icon' ? (
        'V'
      ) : (
        <>
          VERTICAL<span className="marca-vertical-lab__sufixo">LAB</span>
        </>
      )}
    </span>
  )
}
